import script from "./MyAbsenceEditForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAbsenceEditForm.vue?vue&type=script&setup=true&lang=js"

import "./MyAbsenceEditForm.vue?vue&type=style&index=0&id=0b1f88d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b1f88d4"]])

export default __exports__